import axiosInstance from "../../axios";
import AXIOS_ROUTES from "../../axios/routes";
import {
  ICreateWorkoutPayload,
  IUpdateWorkoutPayload,
} from "../../interfaces/store/workout-interface";

export const getWorkoutApi = async (id: string) => {
  return await axiosInstance.get(
    `${AXIOS_ROUTES.workouts.getWorkout}?workoutId=${id}`
  );
};

export const createWorkoutApi = async (data: ICreateWorkoutPayload) => {
  return await axiosInstance.post(
    AXIOS_ROUTES.workouts.createWorkout,
    data.workout
  );
};

export const updateWorkoutApi = async ({
  workoutId,
  workout,
}: IUpdateWorkoutPayload) => {
  return await axiosInstance.put(
    `${AXIOS_ROUTES.workouts.updateWorkout}?workoutId=${workoutId}`,
    workout
  );
};

export const deleteWorkoutApi = async (workoutId: string) => {
  return await axiosInstance.delete(
    `${AXIOS_ROUTES.workouts.deleteWorkout}?workoutId=${workoutId}`
  );
};

export const searchWorkoutsApi = async (data: any) => {
  return await axiosInstance.post(AXIOS_ROUTES.workouts.search, data);
};
